<div class="acr-auth-container">
    <div class="acr-auth-content">
        <form method="post">
            <div class="auth-text">
                <h3>Crea una cuenta nueva</h3>
                <p>Anunciate de forma gratuita y recibe las mejores alertas en vivienda</p>
            </div>
            <div class="form-group">
                <label>Usuario</label>
                <input type="text" class="form-control form-control-light" placeholder="Username" name="username"  [(ngModel)]="user.displayName">
            </div>
            <div class="form-group">
                <label>Dirección de correo</label>
                <input type="email" class="form-control form-control-light" placeholder="Email Address" name="email"  [(ngModel)]="user.email">
            </div>
            <div class="form-group">
                <label>Contraseña</label>
                <input type="password" class="form-control form-control-light" placeholder="Password" name="password" [(ngModel)]="password">
            </div>
            <button type="submit" class="btn-custom secondary btn-block" (click)="registroCorreo()">Registrase</button>
            <div class="auth-seperator">
                <span>Si lo prefieres</span>
            </div>
            <div class="social-login">
                <button type="button" class="acr-social-login facebook"><i class="fab fa-facebook-f"></i> Continúa con Facebook </button>
                <button type="button" class="acr-social-login google"><i class="fab fa-google"></i> Continúa con Google</button>
            </div>
            <p class="text-center mb-0">Ya tienes una cuenta? <a routerLink="/login">Inica Sesión</a> </p>
        </form>
    </div>
    <div class="acr-auth-bg">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="settings"
            class="acr-auth-bg-slider acr-cs-bg-slider">
            <div ngxSlickItem class="acr-auth-bg-item bg-cover bg-center" style="background-image: url('{{item.img}}')"
                *ngFor="let item of images">
                <div class="acr-auth-quote">
                    <h6>{{item.title}}</h6>
                    <p>{{item.text}}</p>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</div>